export default "__VITE_ASSET__CKW_AWGx__"